import { NgModule } from 'ng-metadata/core';
import {LocationsFilterService} from './locationsFilter.service';
import {PrmLocationsFilter} from './locationsFilter.directive';

@NgModule({
    declarations: [
        PrmLocationsFilter
    ],
    providers: [
        LocationsFilterService
    ],
    imports:[
    ]
})
export class LocationsFilterModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locationsFilter/locationFilter.module.ts